{
  "account": {
    "title": "Mitt konto",
    "list": {
      "title": "Konton",
      "description": "Lista över länkade konton och fakturor"
    },
    "form": {
      "name": {
        "title": "Namn",
        "description": "Ditt kontonamn"
      },
      "password": {
        "title": "Lösenord",
        "description": "Ange ett nytt lösenord för ditt konto; lämna tomt för att behålla det nuvarande"
      },
      "emailPreferences": {
        "title": "E-postpreferenser",
        "description": "Välj typer av e-postaviseringar"
      }
    },
    "billing": "Faktureringsuppgifter",
    "subscriptions": "Prenumerationer",
    "manageSubscription": "Hantera prenumeration",
    "popup": {
      "cancel": "Är du säker på att du vill avsluta din prenumeration?<br/>Din webbplats kommer att fortsätta översättas tills den nuvarande prenumerationsperioden löper ut. Därefter inaktiveras översättning.<br/>Observera att du inte kommer att få någon återbetalning för den outnyttjade perioden.",
      "downgrade": "Är du säker på att du vill nedgradera? Nedgraderingen träder i kraft omedelbart.<br/>Observera att du inte kommer att få någon återbetalning för den återstående tiden i den nuvarande faktureringscykeln.<br/>Den nya planens pris tillämpas från nästa faktureringscykel.",
      "default": "Är du säker på att du vill ändra din plan?",
      "resume": "Är du säker på att du vill återuppta din prenumeration?"
    }
  },
  "ai_translation": {
    "header": "AI-översättning",
    "plan": {
      "header": "Prissättning för AI-översättning",
      "used": "Du har använt {words_used} / {words_allowed} översatta ord i dina AI-krediter.",
      "remaining": "Tillgängliga AI-krediter:",
      "words": "ord",
      "add_more_credits": "Lägg till fler AI-krediter",
      "details": {
        "idiomatic_expressions": "Idiomatiska och tekniska uttryck",
        "background_translation": "Översättningar i bakgrunden",
        "best_website": "Webbplatser som kräver perfekt översättningskvalitet",
        "page_context": "Sid- och webbplatssammanhang för översättning",
        "perfect_quality": "Perfekt kvalitet, överkomligt pris",
        "no_recurring": "Ingen återkommande betalning, förutbetald kvot",
        "save_40": "Spara 40 % jämfört med $20-planen",
        "save_50": "Spara 50 % jämfört med $20-planen"
      },
      "quota": "{estimated_words} ord ~ {estimated_pages} sidor"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI-översättning",
        "intro": "Linguise lanserar nu Linguise AI-översättning – en ny premiumfunktion som använder AI LLM-modeller (de senaste Llama-modellerna, optimerade för översättning). Utformad för webbplatser som kräver felfri noggrannhet och tar hänsyn till både sid- och hela webbplatssammanhanget för oöverträffade resultat. Erbud dina kunder toppen av översättningskvalitet och se till att deras budskap når fram perfekt på varje språk.",
        "button": "Uppgradera nu"
      },
      "alert": {
        "description": "Denna funktion ingår inte i din nuvarande plan och kräver ett separat köp.\nAktivera detta tillägg för att låsa upp alla alternativ som listas nedan."
      },
      "languages": {
        "title": "Tillämpa AI-översättning på språk",
        "description": "Välj specifika språk där du vill att AI-översättning ska tillämpas"
      },
      "button": {
        "save": "Spara inställningar"
      },
      "form": {
        "advanced": {
          "title": "Avancerade AI-instruktioner",
          "description": "Avancerade AI-instruktioner"
        },
        "enable_mode": {
          "title": "AKTIVERA AI-ÖVERSÄTTNING",
          "description": "Välj hur du vill att AI-översättning ska aktiveras.\nEndast regler tillämpar följande regler.\nEndast live-redigerare tillåter att aktivera översättning sida för sida från live-redigeringsvyn.\nRegler och live-redigerare använder båda funktionerna.",
          "disabled": "Inaktiverad",
          "rules": "Endast regler",
          "live_editor": "Endast live-redigerare",
          "all": "Regler och live-redigerare"
        },
        "rule_application": {
          "description": "Tillämpa AI-översättning på statiskt innehåll, dynamiskt innehåll eller båda",
          "title": "Tillämpa på innehåll",
          "all": "Allt innehåll",
          "static": "Statiskt innehåll",
          "dynamic": "Dynamiskt innehåll"
        },
        "website_topic": {
          "title": "Webbplatsens ämne",
          "placeholder": "Sushirestaurang...",
          "description": "Definiera ämnet för din webbplats för bättre översättningskvalitet (t.ex. juridik, sushirestaurang, cykeldelar E-butik…)\nAnge webbplatsens ämne på engelska."
        },
        "apply_to_urls": {
          "title": "Tillämpa på URL:er",
          "description": "Välj specifika URL:er där du vill att AI-översättning ska tillämpas",
          "all_urls": "Alla URL:er",
          "selected_urls": "Valda URL:er",
          "label": "URL att tillämpa på",
          "placeholder": "URL att tillämpa på",
          "wildcard": "Jokertecken",
          "regex": "Reguljärt uttryck",
          "add": "Lägg till ny",
          "expression": "Uttryckstyp"
        },
        "apply_languages": {
          "title": "Tillämpa på språk",
          "description": "Välj specifika språk där du vill att AI-översättning ska tillämpas",
          "all_languages": "Alla språk",
          "selected_languages": "Valda språk",
          "placeholder": "Välj språk...",
          "feedback": "Du måste välja ett språk"
        },
        "formality": {
          "title": "Formalitet",
          "description": "Specificera graden av formalitet i översättningar, viktigt för målgrupper och sammanhang.\n\"Neutral\" försöker behålla originalinnehållets formalitet.\n\"Formell\" är för professionellt, affärsmässigt eller juridiskt innehåll (t.ex. använder formella pronomen som \"usted\" på spanska).\n\"Informell\" är för vardagligt, konversationellt innehåll (t.ex. använder \"tú\" på spanska).",
          "neutral": "Neutral",
          "formal": "Formell",
          "informal": "Informell"
        },
        "sentence_structure": {
          "classic": "Klassisk",
          "short": "Korta och kärnfulla meningar",
          "detailed": "Detaljerade och förklarande meningar",
          "title": "Mensktruktur",
          "description": "Definiera preferens för skrivstil."
        },
        "content_purpose": {
          "marketing": "Marknadsföring/promotion (övertalande, engagerande ton)",
          "technical": "Teknisk/instruerande (tydlig, precis, handlingsinriktad)",
          "support": "Kundsupport (empatisk, hjälpsam, lugnande)",
          "legal": "Juridisk/efterlevnad (precis, formell, otvetydig)",
          "educational": "Utbildande (tydlig, strukturerad, tillgänglig)",
          "other": "Annan (på engelska)",
          "title": "Innehållets syfte",
          "description": "Definiera det funktionella syftet med det innehåll som översätts.",
          "other_placeholder": "Beskriv syftet..."
        },
        "target_audience": {
          "title": "Målgrupp",
          "description": "Specificering av den avsedda målgruppen för det översatta innehållet (på engelska).",
          "placeholder": "t.ex. spansktalande föräldrar, EU:s integritetsskyddsombud"
        },
        "override_default_translations": {
          "title": "Åsidosätt standardöversättning",
          "description": "Om detta sätts till JA tvingas innehållet att översättas med AI (Linguise AI) även om det redan översatts av Cloud AI-översättning (standardöversättningsmodellen)."
        },
        "force_replace_before": {
          "title": "Tvinga AI-översättning igen",
          "description": "Översätt på nytt med AI allt innehåll vars AI-översättning skapades före det valda datumet, till exempel innehåll som översatts med en äldre modell. Översättningen görs vid nästa besök på berörda sidor enligt reglerna och använder dina AI-krediter.",
          "before_date": "Före ett datum"
        },
        "model": {
          "current": "Aktuell",
          "title": "Modell",
          "description": "Välj den LLM-översättningsmodell du vill använda",
          "load_error": "Det gick inte att läsa in tillgängliga modeller. Försök igen senare.",
          "thinking_warning": "Den här modellen använder en hög nivå av resonemang (\"tänkande\") och förbrukar avsevärt fler tokens per översättning."
        },
        "override_manual_and_selected": {
          "no_default": "Nej (standard)",
          "title": "Åsidosätt manuella och valda översättningar",
          "description": "Som standard finns en översättning som du har redigerat manuellt alltid kvar på din webbplats, även efter att en AI-förbättrad översättning har skapats. Välj Ja för att visa den AI-förbättrade översättningen i stället. Dina manuella översättningar sparas och du kan byta tillbaka när som helst. Detta gäller även när du översätter sidorna igen för att få nya översättningar; den senaste översättningen används automatiskt."
        }
      },
      "message": {
        "save_success": "Av det nuvarande redan översatta innehållet kommer ungefär {{ai_affected_urls}} sidor att förbättras med AI-översättning.",
        "save_success_only": "Inställningar har sparats."
      }
    },
    "pricing": {
      "plan": {
        "title": "Beställ AI-översättningskvot",
        "buy_button": "KÖP AI-ÖVERSÄTTNINGSPAKET"
      },
      "modal": {
        "title": "Bekräfta planändring",
        "description": "Är du säker på att du vill ändra din AI-översättningsplan?",
        "button_cancel": "Avbryt",
        "button_confirm": "Bekräfta",
        "loading": "Vänta...",
        "amount": "Belopp",
        "credit": "Kredit",
        "total_due": "Totalt att betala"
      },
      "comparison": {
        "title": "Google Cloud AI-översättning\nvs Linguise AI-översättning",
        "list": {
          "0": {
            "google": "Snabba och tillförlitliga översättningar",
            "linguise": "Hanterar idiomatiska och tekniska uttryck"
          },
          "1": {
            "google": "Omedelbara översättningar av alla webbsidor",
            "linguise": "Genererar översättningar i bakgrunden"
          },
          "2": {
            "google": "Bästa kvalitet, lågt pris",
            "linguise": "Perfekt kvalitet, överkomligt pris"
          },
          "3": {
            "google": "Passar bäst för stora webbplatser eller låg budget",
            "linguise": "Bäst för webbplatser som kräver perfekt översättningskvalitet"
          },
          "4": {
            "google": "Sidkontext för översättning",
            "linguise": "Sido- och webbplatskontext för översättning"
          }
        }
      },
      "botom_banner": {
        "title": "Upplev oöverträffad översättningsnoggrannhet med den",
        "sub_title": "nya Linguise AI-översättningen",
        "description": "Linguise förbättrar sina automatiska översättningstjänster med introduktionen av Linguise AI-översättning, ett kraftfullt nytt alternativ som använder banbrytande AI-översättnings-LLM (de senaste Llama-modellerna optimerade för översättning). Detta tillägg ger webbutvecklare och webbyråer en ännu högre nivå av översättningskvalitet, idealisk för projekt där perfektion är avgörande. Linguise AI-översättning kompletterar vår befintliga, högkvalitativa Google Cloud AI-översättning och ger dig större flexibilitet och precision."
      }
    },
    "success": {
      "tab_title": "Tack för att du köpte AI-översättningsabonnemanget!",
      "title": "Tack för att du köpte AI-översättningsabonnemanget!",
      "subtitle": "Ditt AI-översättningsabonnemang har köpts framgångsrikt!",
      "message": "Du kan hantera ditt AI-översättningsabonnemang på sidan för AI-översättningsinställningar.",
      "home": "Hantera AI-översättning"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Namn",
        "description": "Faktureringskontots namn"
      },
      "phone": {
        "title": "Telefon",
        "description": "Faktureringskontots telefon"
      },
      "email": {
        "title": "E-post",
        "description": "Faktureringskontots e-post"
      },
      "address": {
        "title": "Adress",
        "description": "Faktureringskontots adress",
        "city": "Stad",
        "country": "Land",
        "address1": "Adress 1",
        "address2": "Adress 2",
        "postal": "Postnummer",
        "state": "Stat"
      },
      "tax": {
        "title": "Skattenummer"
      }
    }
  },
  "checkouts": {
    "header": "Kassa",
    "payment_method": "Välj betalningsmetod",
    "stripe_card": "Kreditkort (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Ange ny faktureringsadress",
      "existing": "Använd befintlig adress"
    },
    "pay_stripe": "Bekräfta och betala",
    "terms": "Genom att bekräfta din prenumeration tillåter du Linguise att debitera dig för framtida betalningar i enlighet med våra villkor. Du kan när som helst avbryta din prenumeration.",
    "coupon": {
      "title": "Har du en kupong?",
      "placeholder": "Infoga din kupongkod här",
      "apply": "Tillämpa",
      "percent": "{{0}} % rabatt"
    },
    "add_new": "Lägg till ny",
    "use_existing": "Använd befintlig betalningsmetod",
    "recurring": {
      "month_single": "Faktureras månadsvis",
      "month_many": "Faktureras var {{count}} månad",
      "year_single": "Faktureras årsvis",
      "year_many": "Faktureras var {{count}} år",
      "day_single": "Faktureras dagligen",
      "day_many": "Faktureras var {{count}} dag",
      "week_single": "Faktureras varje vecka",
      "week_many": "Faktureras var {{count}} veckor"
    },
    "add_new_no_stripe": "Lägg till nytt kort",
    "summary": {
      "title": "Sammanställning",
      "subtotal": "Delsumma",
      "total": "Totalt"
    }
  },
  "dashboard": {
    "main": {
      "title": "Instrumentpanel"
    },
    "statistics": {
      "main_title": "Statistik senaste 30 dagarna",
      "characters": "Översatta tecken",
      "words": "Översatta ord",
      "bandwidth": "Inkommande bandbredd",
      "request": "Förfrågningar",
      "page_views": "Sidvisningar per språk (senaste 30 dagarna)",
      "multilingual_views": "Flerspråkiga sidvisningar (senaste 30 dagarna)",
      "most_page_viewed": "20 mest visade sidor (senaste 30 dagarna)",
      "no_data_yet": "Ingen data tillgänglig än",
      "th_language": "Språk",
      "th_page_views": "Sidvisningar",
      "real_visitors": "Riktiga besökare",
      "crawler": "Webbcrawler"
    },
    "planHints": {
      "subscribeButton": "Prenumerera",
      "upgradeButton": "Uppgradera",
      "usedWords": "Du använder för närvarande {words_used} ord",
      "noPlan": "Ingen plan är aktiverad för denna domän. Prenumerera på en plan och börja översätta din webbplats",
      "noPlanShopify": "Ingen plan är aktiverad för denna domän. Prenumerera på en plan i din Shopify-instrumentpanel och börja översätta din webbplats",
      "trialUsage": "Du använder för närvarande {words_used} ord av de {words_allowed} ord som ingår i testplanen.",
      "trialEnds": "Den första månadens test är aktivt till {trial_ends}.",
      "subscribeMessage": "Prenumerera innan den tar slut för att hålla din webbplats översatt",
      "subscribeMessageShopify": "Prenumerera från din Shopify-instrumentpanel innan den tar slut för att hålla din webbplats översatt",
      "trialReachedLimit": "Du har nått det maximala antalet översatta ord för testperioden.\nPrenumerera på en av våra planer för att fortsätta översätta din webbplats.",
      "paidUsage": "Du har använt {words_used} / {words_allowed} översatta ord i din plan.",
      "paidReachedLimit": "Du har nått det maximala antalet översatta ord för den aktuella planen.\nUppgradera din plan för att fortsätta översätta innehållet på din webbplats.",
      "trialOfferedUsage": "Du använder för närvarande {words_used} ord av de {words_allowed} ord som ingår i testplanen.(Inklusive de {free_words} erbjudna orden)",
      "paidOfferedUsage": "Du har använt {words_used} / {words_allowed} översatta ord i din plan.(Inklusive de {free_words} erbjudna orden)",
      "noPlanExtra": "Observera att inaktiva domäner och deras data raderas regelbundet.",
      "planRecommended": "Baserat på din nuvarande översättningsvolym rekommenderas planen:",
      "planMaximumWords": "{{words}} ord",
      "notHaveTranslatedWords": "Du har ännu inte gjort några översättningar"
    },
    "translationSetup": {
      "kicker": "INSTÄLLNING AV UNDERDOMÄN",
      "title": "Kontrollera översättningsinställningar",
      "description": "Granska DNS, översatta värdar, åtkomst till originalwebbplatsen och kontogränser.",
      "starting": "Kontrollerar...",
      "button": "Kontrollera inställning",
      "viewLatest": "Visa senaste resultat",
      "viewCurrent": "Visa aktuell kontroll",
      "runAgain": "Kör kontrollen igen",
      "viewDetails": "Visa information",
      "hideDetails": "Dölj information",
      "error": "Det går inte att kontrollera inställningen",
      "allPassed": "Alla kontroller godkändes",
      "setupNeedsAttention": "Inställningen kräver uppmärksamhet",
      "setupNeedsAttentionDescription": "En eller flera kontroller misslyckades. Granska punkterna nedan eller kontakta Linguise-supporten.",
      "lastChecked": "Senast kontrollerad {{time}}",
      "domainOwnership": "Domänägarskap",
      "domainOwnershipDescription": "Verifieringspost hittades",
      "domainOwnershipFailure": "DNS-posten för domänägarskap kunde inte verifieras.",
      "translatedHosts": "Översatta värdar",
      "translatedHostsDescription": "{{count}} språkvärdar kontrollerades",
      "translatedHostsFailure": "En eller flera CNAME-poster för språk är felaktiga.",
      "subdomainPage": "Underdomänssida",
      "subdomainPageDescription": "{{count}} översatta sidor accepterar HTTPS",
      "subdomainPageFailure": "TLS-anslutningen misslyckades när en eller flera översatta sidor öppnades.",
      "originalSite": "Originalwebbplats",
      "originalSiteDescription": "Kontroller av DNS, TLS och svar för originalwebbplatsen",
      "originalSiteFailure": "Kontrollen av originalwebbplatsens DNS, TLS eller svar misslyckades.",
      "documentationAdvice": {
        "dns": "Granska DNS-inställningar",
        "tls": "Granska HTTPS-inställningar",
        "origin": "Granska originalwebbplatsens inställningar",
        "diagnostic": "Granska felsökningsstegen"
      },
      "evidence": {
        "originDns": "Ursprunglig DNS",
        "originTls": "Ursprunglig TLS",
        "originHttp": "Ursprungligt svar",
        "observedTargets": "Observerade mål",
        "recordCount": "Poster hittades",
        "addressCount": "Adresser hittades",
        "statusCode": "HTTP-status",
        "redirect": "Omdirigering",
        "expiresAt": "Certifikatet upphör att gälla",
        "raw": "{{key}}",
        "noValue": "Inget värde"
      },
      "checkerError": "Vissa kontroller kunde inte slutföras.",
      "coreLocation": "Kontrollerad från {{location}}",
      "status": {
        "queued": "I kö",
        "running": "Pågår",
        "completed": "Slutförd",
        "failed": "Misslyckades",
        "passed": "Godkänd",
        "warning": "Varning",
        "unknown": "Okänd",
        "skipped": "Överhoppad",
        "not_applicable": "Ej tillämpligt"
      }
    },
    "throttling": {
      "title": "Översättningsbegränsning",
      "description": "Tillfälliga användningsgränser",
      "unavailable": "Tillfälliga översättningsgränser är inte tillgängliga",
      "window": "{{used}} / {{max}} ord",
      "resetsIn": "Återställs om {{time}}",
      "throttled": "Översättningen är tillfälligt pausad",
      "throttledDescription": "En tillfällig användningsgräns har nåtts. Översättningen återupptas när perioden återställs."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "STEG {{step}} AV {{total}}",
      "doneLabel": "KLART, DU KAN BÖRJA ÖVERSÄTTA!",
      "finish": {
        "title": "",
        "description": "Detta är API-nyckeln att använda på din webbplats"
      },
      "instructions": "Installationsinstruktion",
      "domainSetting": "Domäninställning",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP-skript",
        "wizardWordpressStep1": "1. Installera ",
        "wizardWordpressStep2": "\n 2. I plugininställningarna kopierar och fyller du i din API-nyckel\n",
        "wizardWordpressStep3": "3. Du är redo att översätta\n\n",
        "wizardWordpressStep4": "För mer detaljerade instruktioner, vänligen se vår dokumentation: ",
        "wizardJoomlaStep1": "1. Joomla-paketlänk: ",
        "wizardJoomlaStep2": "\n2. I tilläggets konfigurationsinställningar kopierar och fyller du i din API-nyckel",
        "wizardJoomlaStep3": "3. I modulkonfigurationen anger du de språk du vill visa och placerar din modul där du behöver den.",
        "wizardJoomlaStep4": "\n4. Du är redo att översätta\n\n",
        "wizardPhpStep1": "1. Ladda ner vårt php-skript och här ",
        "wizardPhpStep2": "\n2. Följ installationsinstruktionerna på vår dokumentsida här ",
        "wizardPhpStep3": "\n3. Lägg till modulen på dina sidor.",
        "wizardPhpStep4": "\nKopiera följande kod och lägg till den i head på din html-sida, den kommer automatiskt att visa switcher-modulen\n",
        "dispatchStep1": "Vi har skickat de nödvändiga uppgifterna till Linguise-pluginet, du kan nu stänga följande fönster.",
        "dispatchStep2": "Om token saknas när du stänger detta fönster, vänligen kopiera följande token: ",
        "dispatchStep3": "Du kan också kopiera detta kodavsnitt för att automatiskt aktivera vår flagg-switcher",
        "wizardOtherStep1": "Följ instruktionerna nedan för att installera Linguise på din domän.\n",
        "wizardOtherStep2": "Kopiera följande kod och lägg till den i head på din html-sida, den kommer automatiskt att visa switcher-modulen.\n"
      },
      "trialAlreadyUsed": "Det verkar som att du redan har använt din gratis provperiod, så du behöver skaffa översättningskvot\nVänligen prenumerera på en plan eller kontakta oss om du behöver förlänga din provperiod.",
      "usefulLinks": "Användbara länkar för att komma igång",
      "linkDocumentation": "Dokumentation",
      "linkExtensionDl": "Nedladdning av tillägg",
      "linkSubscribe": "Prenumerera på en plan nu",
      "linkDashboard": "Gå till kontrollpanelen",
      "exclusion": {
        "title": "Företags- och produktnamn",
        "description": ""
      },
      "finishButton": "Slutför installationen",
      "subdomains": "Subdomäner",
      "subdomain_setup": "Konfigurera domän",
      "subdomain_auto_setup": "Anslut din DNS automatiskt",
      "subdomain_manual_setup": "Lägg till DNS-poster själv",
      "subdomain_skip": "Gör det senare",
      "auto_subdomains_info": "Din webbplatsbyggare CMS kräver en DNS-konfiguration för att ställa in språk per subdomän (t.ex. es.domain.com).",
      "auto_subdomains_info_2": "Du kan göra det automatiskt med Entri. Klicka bara på knappen \"Anslut din DNS automatiskt\" för att börja ansluta till din DNS-hanterare och lägga till dem med Entri.",
      "auto_subdomains_info_manual": "Eller så kan du konfigurera din domän manuellt genom att klicka på knappen \"Lägg till DNS-poster själv\".",
      "breadcrumbs": {
        "step1": "Steg 1: Domän, CMS och språk",
        "step2": "Steg 2: Språk-DNS",
        "step3": "Steg {{step}}: Installationsanvisningar"
      }
    },
    "form": {
      "urls": {
        "dash": "Bindestreck -",
        "underscore": "Understreck _",
        "title": "Översätt URL:er",
        "description": "Vill du översätta på alla sidor",
        "char_description": "Tecken att använda för att ersätta icke tillåtna tecken i URL:er",
        "advertisement_title": "⚠ Du har ställt in många språk.\n",
        "advertisement": "Vi rekommenderar vanligtvis att börja översätta webbplatser med få språk först. Du får en uppfattning om hur många ord din webbplats har. Det är också bättre för SEO, eftersom Google-botar kommer att genomsöka alla dina sidor snabbare om du har färre sidor från början. Efter en vecka kan du lägga till några fler språk och så vidare."
      },
      "url": {
        "title": "Url",
        "description": "Ange din huvuddomäns URL som börjar med http:// eller https://",
        "placeholder": "Domän-URL",
        "advertisement_http": {
          "title": "Du använder inte https-protokollet",
          "description": "Vänligen kontrollera att din domän faktiskt inte använder https-protokollet, vilket numera rekommenderas."
        },
        "advertisement_www": {
          "title": "Din subdomän är inte www",
          "description": "För det mesta är standard-subdomänen www (t.ex. https://www.mydomain.com). Detta kanske inte är ditt fall men vänligen dubbelkolla att domänen du vill lägga till är korrekt."
        },
        "invalid_url": {
          "line1": "Vi kunde inte hitta din domän. Vänligen kontrollera att din domän är publikt tillgänglig via Internet och att den inte omdirigeras till en annan plats.",
          "line2": "Om du är säker på att din domän är tillgänglig kan du hoppa över domänverifiering och trycka på knappen \"Nästa steg\" igen",
          "contact": "I vilket fall som helst kan du kontakta oss på",
          "force": "Hoppa över domänverifiering"
        },
        "invalid_subdomain_url": "Denna webbadress är inte tillåten. Underdomäner måste ha formen: https://www.domain.tld eller https://domain.tld utan underkatalog."
      },
      "account": {
        "title": "Konto",
        "description": "Välj ett konto att tilldela denna domän",
        "placeholder": "Välj konto...",
        "feedback": "Du måste välja ett konto"
      },
      "platform": {
        "title": "Plattform",
        "description": "Vänligen välj din webbplattform efter CMS-namn.",
        "learn": "Läs hur du väljer det",
        "placeholder": "Sök plattform efter CMS-namn...",
        "info": {
          "title": "⚠ Denna plattform har lagts till nyligen.\n",
          "desc": "Denna webbplatsbyggarplattform stöds av Linguise, även om den har lagts till nyligen. Om du upplever några problem, vänligen kontakta oss med den direkta support-e-posten:"
        },
        "description_read_only": "Plattformen som din webbplats använder",
        "feedback": "Du måste välja en plattform"
      },
      "language": {
        "title": "Språk",
        "description": "Välj din webbplats grundspråk",
        "placeholder": "Välj språk...",
        "feedback": "Du måste välja ett språk",
        "description_read_only": "Grundspråket för din webbplats"
      },
      "token": {
        "title": "API-nyckel",
        "description": "Detta är API-nyckeln som ska kopieras till din webbplats",
        "copy": "Kopiera till urklipp",
        "reset": "Återställ API-nyckel",
        "reset_confirm": "Vänligen bekräfta återställning av API-nyckel"
      },
      "languages": {
        "title": "Översättningsspråk",
        "description": "Välj de språk du vill att din webbplats ska kunna översättas till",
        "placeholder": "Välj språk...",
        "feedback": "Du måste välja ett språk"
      },
      "defaultRules": {
        "title": "Standardregler",
        "description": "Vi har definierat en uppsättning regler som måste användas för att förbättra översättningen och undvika oönskat innehåll som ska översättas, som WordPress-instrumentpanelen.\nDu kan ta bort eller redigera dessa regler senare om du vill."
      },
      "disallow_deletion": "Du kan inte ta bort domän med aktiv prenumeration",
      "delete_confirm": "Vänligen bekräfta borttagning av domän",
      "delete": "Ta bort domän",
      "dynamic": {
        "title": "Översätt dynamiskt innehåll",
        "description": "Dynamiskt innehåll som genereras av JavaScript och AJAX-förfrågningar kommer att översättas (Detta alternativ kommer att öka dina översättningsanvändningar)"
      },
      "partial_translations": {
        "title": "Tillåt partiell översättning",
        "description": "Om ditt konto har nått sin översättningskvot men sidan fortfarande behöver översättas, kan Linguise fortsätta att visa sidan med det innehåll som redan har översatts.\nVissa delar av sidan kommer dock förbli oöversatta tills du uppgraderar din kvot.\n\nMedan en liten mängd oöversatt innehåll vanligtvis inte skadar SEO, kan för mycket oöversatt innehåll påverka användarupplevelsen negativt.\nFör att hantera detta kan du ställa in en tröskel för den procentandel oöversatt innehåll som tillåts på en sida. Om det oöversatta innehållet överstiger denna tröskel kommer användare automatiskt att omdirigeras till originalspråkversionen av sidan.",
        "never": "Aldrig"
      },
      "translate_error_pages": {
        "title": "Översätt felsidor",
        "description": "Linguise kan översätta alla felsidor, men om din felsida innehåller dynamiskt innehåll som IP-adress eller förfrågnings-ID bör du undvika att översätta dessa sidor.",
        "not_found_page": {
          "title": "Översätt 404-sida"
        },
        "error_page": {
          "title": "Översätt andra felsidor"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Befintlig domän hittad",
          "description": "En befintlig domän har hittats för denna användare, vill du använda den?"
        }
      },
      "search_tl": {
        "title": "Sök översättningar",
        "description": "Aktivera sök översättningar för din webbplattform (Experimentell, detta alternativ kommer att öka dina översättningsanvändningar)"
      },
      "shopify_promo": {
        "info": "Goda nyheter! Vi har nu en Shopify-app som du kan installera från Shopify App Store",
        "hyperlink": "Klicka här och gör Linguise-installationen från appen.",
        "next_btn": "Gå till Shopify-butiken för att installera appen",
        "info_legacy": "Goda nyheter! Vi har nu en Shopify-app som du kan installera från Shopify App Store",
        "description_legacy": "Välj plattformen \"Shopify\" istället för \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Goda nyheter! Vi har nu en Wix-app som du kan installera från Wix App Market.",
        "hyperlink": "Klicka här och gör Linguise-installationen från appen.",
        "next_btn": "Gå till Wix App Market för att installera appen",
        "info_legacy": "Goda nyheter! Vi har nu en Wix-app som du kan installera från Wix App Market.",
        "description_legacy": "Välj plattformen \"Wix\" istället för \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Du kan inte ta bort den här domänen medan en AI-kvot fortfarande är tillgänglig.\n\nKontakta vårt supportteam om du vill ta bort denna domän på",
      "language_removal": {
        "card": {
          "title": "Ta bort översättningar för borttagna språk",
          "description": "Dessa språk har tagits bort från din webbplats, men deras sparade översättningar räknas fortfarande in i din kvot. Ta bort dem för att få tillbaka orden.",
          "button": "Ta bort översättningar"
        },
        "hint": "Orden som användes läggs tillbaka i din kvot. Du kan göra detta en gång var {{days}} dag per webbplats.",
        "modal": {
          "title": "Ta bort översättningar?",
          "intro": "Dessa översättningar tas bort permanent:",
          "warning": "Det går inte att ångra. Orden som användes läggs tillbaka i din kvot, vilket kan ta några minuter.",
          "limit": "Du kan göra detta en gång var {{days}} dag per webbplats.",
          "confirm": "Ta bort översättningar"
        },
        "scheduled": "Översättningarna tas bort och din kvot uppdateras snart.",
        "cooldown": "Översättningarna för den här webbplatsen togs nyligen bort. Du kan ta bort dem igen den {{date}}.",
        "latest_completed": {
          "title": "Senaste slutförda borttagning",
          "description": "Se borttagna språk och ord som har återförts till din kvot.",
          "languages": "Borttagna språk",
          "words_returned": "Ord återförda till din kvot: {{words}}",
          "completed_at": "Slutfört {{date}}"
        },
        "status": {
          "recent_title": "Senaste borttagningen av översättningar",
          "recent_description": "Följ den senaste borttagningen och se när nästa blir tillgänglig.",
          "progress_title": "Förlopp för borttagning",
          "loading": "Kontrollerar förloppet för borttagningen...",
          "unavailable": "Det gick inte att läsa in förloppet. Uppdatera sidan och försök igen.",
          "label": "Status",
          "pending": "I kö",
          "processing": "Pågår",
          "completed": "Slutfört",
          "failed": "Misslyckades",
          "unknown": "Status inte tillgänglig",
          "percent": "{{percent}} % klart",
          "current_stage": "Aktuellt steg: {{stage}}",
          "processed": "{{processed}} poster har bearbetats",
          "processed_total": "{{processed}} av {{total}} poster har bearbetats",
          "requested_at": "Begärdes {{date}}",
          "started_at": "Startades {{date}}",
          "completed_at": "Slutfört {{date}}",
          "cooldown_period": "Du kan göra detta en gång var {{days}} dag per webbplats.",
          "cooldown_blocked": "Det går inte att starta en ny borttagning ännu.",
          "stage": {
            "queued": "Väntar på att starta",
            "processing": "Pågår",
            "refund_summary": "Beräknar återförda ord",
            "search_translations": "Tar bort sököversättningar",
            "url_translations": "Tar bort URL-översättningar",
            "translations": "Tar bort översättningar",
            "completed": "Slutfört",
            "failed": "Misslyckades",
            "unknown": "Pågår"
          }
        },
        "forbidden": "Du har inte behörighet att ta bort översättningar."
      }
    },
    "main": {
      "edit": "Redigera domän",
      "add": "Lägg till domän",
      "wizard": "Välkommen! Guide för att skapa ny domän",
      "common": "Domän"
    },
    "notice": {
      "broken_card": "Vi kunde inte förnya din plan för {{url}} med den aktuella betalningsmetoden, vänligen uppdatera ditt betalningskort",
      "quota_reached": "Din översättningskvot för {{url}} har nåtts, vänligen uppgradera för att återuppta din webbplatsöversättning",
      "ai_no_subscription": "AI-översättning för {{url}} kräver en aktiv prenumeration eller aktiv provperiod. Det kommer att stoppas utan en sådan, vänligen uppgradera för att fortsätta",
      "important": "Viktigt",
      "quota_reached_button": "Uppgradera din plan nu",
      "broken_card_button": "Uppdatera ditt betalkort",
      "ai_no_subscription_button": "Uppgradera din plan nu",
      "quota_warning": "Din översättningskvot för {{url}} har nått {{throttling_used_percent}}%, detta skulle återställas om {{ttl}}",
      "locked": "Domänen {{url}} är för närvarande låst för migrering, du kan fortfarande komma åt din webbplats men kan inte redigera eller lägga till nya översättningar!"
    },
    "subdomains": {
      "config_ok": "Subdomäners DNS har konfigurerats korrekt.",
      "config_invalid": "Subdomäners DNS kräver ytterligare konfiguration för att fungera.",
      "config_check": "Subdomäners DNS-konfiguration kontrolleras, vänta...",
      "entri_timeout": "Entri rapporterade att utbredningsprocessen för dina subdomäners DNS har löpt ut; du måste försöka igen eller göra det manuellt.",
      "entri_process": "Din DNS har lagts till med Entri och det tar vanligtvis 10–30 minuter att spridas (tillämpa alla dina språksubdomäner som es.domain.com). Om DNS-valideringen inte är klar efter 24 timmar kan du kontakta vårt supportteam: support@linguise.com",
      "entri_ok": "DNS-utbredning pågår! Väntar på spridning...",
      "infos": "Du måste lägga till dessa DNS-poster i dina DNS-domänposter för att aktivera översättningen. Klicka på kryssrutan när det är klart. Det är möjligt att DNS-poster kan ta lite tid att distribuera, så du kan behöva återvända efter några minuter eller timmar.",
      "check": "Kontrollera DNS-konfigurationen"
    },
    "subscription": {
      "next_payment_amount": "Kommande avgifter",
      "next_payment_date": "Nästa betalningsdatum",
      "invoice": {
        "header": "Fakturahistorik",
        "date": "Datum",
        "amount_due": "Belopp",
        "status": "Status",
        "actions": "Åtgärder",
        "description": "När transaktioner finns tillgängliga kan du se dem här.",
        "status_text": {
          "draft": "Utkast",
          "failed": "Misslyckad",
          "open": "Väntande",
          "paid": "Betald",
          "retrying": "Försöker igen",
          "uncollectible": "Oinlösbar",
          "void": "Ogiltig"
        },
        "view": "Visa",
        "empty": "Det finns inga senaste fakturor för denna prenumeration",
        "retry_payment": "Försök igen"
      },
      "next_cancellation": "Uppsägningsdatum",
      "cancel": "Avsluta prenumeration",
      "change_plan": "Byt plan",
      "change": "Ändra",
      "suspend": "Pausa betalning",
      "resume": "Återuppta prenumeration",
      "back": "Tillbaka",
      "save": "Spara",
      "confirm_resume": "Är du säker på att du vill återuppta denna prenumeration?",
      "confirm_cancel": "Är du säker på att du vill avsluta denna prenumeration?",
      "confirm_header": "Är du säker?",
      "missing_status": "Denna prenumeration saknas",
      "not_found": "Ingen prenumeration hittades för denna domän",
      "confirm_manual_retry": "Är du säker på att du vill försöka genomföra denna betalning igen?",
      "no_payment_method": "Okänd",
      "remove_billing": "Ta bort",
      "shopify_maneged": "Denna prenumeration hanteras av Shopify. Hantera den från din Shopify-adminpanel.",
      "unknown_plan": "Okänt paket"
    }
  },
  "domain_listing": {
    "add": "Lägg till webbplats",
    "select": "Välj en domän"
  },
  "editable": {
    "number": "nummer {{id}}"
  },
  "footer": {
    "about": "Om",
    "support": "Support"
  },
  "frontendEditor": {
    "main": "Live-redigerare",
    "description": "Live Editor hjälper dig att direkt redigera översättningar på din webbplats.",
    "button": "Öppna Live Editor",
    "language_selection": "Val av översättningsspråk",
    "video_label": "Lär dig hur du använder live editor"
  },
  "general": {
    "403": {
      "tab_title": "Hoppsan – 403-fel",
      "title": "Åtkomst nekad",
      "message": "Det verkar som att du inte har tillgång till den begärda sidan.",
      "home": "Återvänd hem"
    },
    "404": {
      "tab_title": "Hoppsan – 404-fel",
      "title": "Sidan hittades inte",
      "message": "Det verkar som att du har tagit fel väg. Oroa dig inte... det händer den bäste. Här är ett litet tips som kan hjälpa dig tillbaka på rätt spår.",
      "home": "Återvänd hem"
    },
    "500": {
      "tab_title": "500-fel",
      "title": "Internt serverfel",
      "message": "Varför inte försöka uppdatera sidan? eller kontakta oss",
      "home": "Återvänd hem"
    },
    "fields": {
      "alert": "Vissa fält är ogiltiga, vänligen korrigera de felaktiga fälten.",
      "invalid": "Detta fält är ogiltigt",
      "phone_re": "Telefonnumret är ogiltigt",
      "phone_invalid": "Telefonnumret är ogiltigt",
      "email": "E-postadressen är ogiltig"
    },
    "table": {
      "no_data": "Det finns ingen data här än..."
    },
    "saving": "Sparar...",
    "save": "Spara",
    "save_and_quit": "Spara och avsluta",
    "invite": "Bjud in",
    "cancel": "Avbryt",
    "yes": "Ja",
    "no": "Nej",
    "nextStep": "Nästa steg",
    "loading": "Vänta medan applikationen laddas",
    "goback": "Gå tillbaka",
    "manage": "Hantera",
    "delete": "Ta bort",
    "deleting": "Tar bort...",
    "confirm": "Bekräfta",
    "unknown": "Okänt",
    "hide": "Dölja",
    "show": "Visa",
    "on": "På",
    "off": "Av",
    "default": "Standard"
  },
  "home": {
    "header": "Hem",
    "manage": "Hantera prenumeration",
    "canceled": "Schemalagd för uppsägning",
    "activate_now": "Aktivera nu",
    "activate_plan_now": "Prenumerera nu",
    "upgrade_plan_now": "Uppgradera plan nu",
    "trial_message_part_1": "Du är för närvarande på testplanen, ",
    "trial_message_part_2": "du kan aktivera ett medlemskap när som helst.",
    "add": "Lägg till domän",
    "table": {
      "title": "Domäner",
      "description": "Lista över dina domäner, klicka på domänen för att hantera översättningar"
    },
    "domains": {
      "empty": "Du har inga domäner på detta konto"
    },
    "accountsList": {
      "title": "Konton",
      "add": "Lägg till nytt konto",
      "name": "Kontonamn"
    },
    "update_credit_card": "Uppdatera kreditkortsuppgifter",
    "cancelling_subs": "Avslutas den {{0}}",
    "resume_subscription": "Återuppta prenumeration",
    "shopify_managed": "Hanteras av Shopify",
    "trial_ends_at": "Slutar kl. {{0}}",
    "free_trial": "Gratis provperiod",
    "no_subs": "Ingen aktiv prenumeration"
  },
  "invoices": {
    "title": "Fakturor",
    "list": {
      "title": "Fakturalista"
    },
    "table": {
      "customer": "Kund",
      "domain": "Domän",
      "amountPaid": "Betalt belopp",
      "status": "Status",
      "date": "Datum",
      "invoice": "Faktura",
      "pay": "Betala faktura",
      "actions": "Åtgärder",
      "deleted_domain": "Domän borttagen",
      "plan_name": "Abonnemang",
      "action": "Åtgärd"
    },
    "listPending": {
      "title": "Lista över väntande fakturor"
    }
  },
  "language_settings": {
    "display": "Språklistvisning",
    "position": "Position",
    "display_help_text": "Visa flagga och/eller språknamn. Standardspråkväxlarens position kan vara var som helst i innehållet eller i en fast position som förblir fast eller rör sig vid scrollning",
    "side_by_side": "Sida vid sida",
    "dropdown": "Rullgardinsmeny",
    "popup": "Popup",
    "flag": "Flagga",
    "lang_name": "Språknamn",
    "lang_short_name": "Korta namn",
    "positions": {
      "in_place": "På plats",
      "top_left": "Övre vänster",
      "top_left_no_scroll": "Övre vänster (ej scroll)",
      "top_right": "Övre höger",
      "top_right_no_scroll": "Övre höger (ej scroll)",
      "bottom_left": "Nedre vänster",
      "bottom_left_no_scroll": "Nedre vänster (ej scroll)",
      "bottom_right": "Nedre höger",
      "bottom_right_no_scroll": "Nedre höger (ej scroll)"
    },
    "lang_names_display": {
      "title": "Visning av språknamn",
      "help_text": "I språkväxlaren, visa språknamnen på engelska eller på originalspråket, t.ex. French eller Français",
      "english": "Engelska",
      "native_languages": "Ursprungliga språk"
    },
    "flag_shape": {
      "title": "Flaggform",
      "help_text": "Använd runda svg- eller rektangulära svg-flaggikoner",
      "round": "Rund",
      "rectangular": "Rektangulär"
    },
    "english_flag_type": {
      "title": "Engelsk flagga",
      "help_text": "Använd Storbritanniens eller USA:s flagga för engelska",
      "usa": "USA-flagga",
      "great_britain": "Storbritanniens flagga"
    },
    "german_flag_type": {
      "title": "Tysk flagga",
      "help_text": "Använd Österrikes eller Tysklands flagga för tyska",
      "german": "Tysk flagga",
      "austria": "Österrikisk flagga"
    },
    "spain_flag_type": {
      "title": "Spansk flagga",
      "help_text": "Använd Mexikos eller Spaniens flagga för spanska",
      "spanish": "Spansk flagga",
      "mexico": "Mexikansk flagga",
      "peruvian": "Peruansk flagga"
    },
    "portugal_flag_type": {
      "title": "Portugisisk flagga",
      "help_text": "Använd Portugals eller Brasiliens flagga för portugisiska",
      "portugal": "Portugisisk flagga",
      "brazil": "Brasiliansk flagga"
    },
    "taiwanese_flag_type": {
      "title": "Taiwanesisk flagga",
      "help_text": "Använd Taiwanesisk eller Kinesisk flagga för taiwanesiska",
      "taiwanese": "Taiwanesisk flagga",
      "chinese": "Kinesisk flagga"
    },
    "flag_border_radius": {
      "title": "Flagghörnradie (px)",
      "help_text": "Om du använder rektangulär flaggform kan du anpassa hörnradie i pixlar"
    },
    "flag_width": {
      "title": "Flaggstorlek (px)",
      "help_text": "Välj flaggstorlek i pixlar. Det påverkar inte bildvikten eftersom det är .svg-format"
    },
    "lang_color": {
      "color_title": "Textfärg för språknamn",
      "color_help_text": "Välj en standardtextfärg för dina språknamn",
      "hover_color_title": "Textfärg för språknamn vid hovring",
      "hover_color_help_text": "Välj textfärg för dina språknamn när muspekaren hovrar",
      "color_popup_title": "Språktextfärg i popup",
      "color_popup_help_text": "Färg på språknamnet i popup- eller rullgardinsområdet",
      "hover_color_popup_title": "Språktextfärg i popup vid hovring",
      "hover_color_popup_help_text": "Välj textfärg för språknamnet i popup eller rullgardin vid muspekarens hovring"
    },
    "flag_box_shadow": {
      "shadow_title": "Flaggskugga",
      "shadow_help_text": "Färg och skuggstorlek för dina språkflaggor",
      "hover_shadow_title": "Flaggskugga vid hovring",
      "hover_shadow_help_text": "Färg och skuggstorlek för dina språkflaggor när muspekaren hovrar",
      "shadow_h_offset": "Horisontell skuggförskjutning (px)",
      "shadow_v_offset": "Vertikal skuggförskjutning (px)",
      "shadow_blur": "Suddighet (px)",
      "shadow_spread": "Spridning (px)",
      "shadow_color": "Skuggfärg"
    },
    "order": "Språkordning",
    "language_order_help": "Den ordning som språken visas i språkväxlaren. Du kan dra och släppa språken för att ändra ordning.",
    "order_reset": "Återställ ordning",
    "language_order_dragdrop": "Du kan dra och släppa språken för att ändra ordning.",
    "popup_lang_name": "Popup-språknamn",
    "preview": "Förhandsgranskning av språk"
  },
  "link": {
    "form": {
      "original": {
        "title": "Ursprunglig källa",
        "description": "Lägg till din ursprungliga länk-URL och ersätt den nedan per språk för att översätta",
        "srcset_description": "Du redigerar en bild-URL. Läs dokumentationen, särskilt om du använder srcset eller inte vet vad det är",
        "link": "Länk",
        "match_link": "Matchningsläge",
        "match_exact": "Exakt",
        "match_wildcard": "Jokertecken",
        "match_regex": "Reguljärt uttryck"
      },
      "alternative_languages": {
        "title": "Länkar att ersätta",
        "description": "Ersätt medielänkar och externa länkar över hela dina sidor, efter språk…",
        "link": "Länk att ersätta"
      },
      "error": {
        "atLeastOne": "Lägg till minst en översättning.",
        "url": "Webbadressen är ogiltig",
        "extension": "Länken måste ha en filändelse, men det kan inte vara .html eller .php. Länken får inte heller innehålla någon språksökväg t.ex. \"/fr\"",
        "regex": "Regexen är ogiltig",
        "wildcard": "Wildcard-länken har ett ogiltigt protokoll"
      }
    },
    "main": {
      "parent": "Länkar",
      "edit": "Redigera länk"
    }
  },
  "links": {
    "title": "Hantering av media- och externa länkar",
    "description": "Lista och redigera dina webbplats medialänkar eller externa länkar.",
    "add": "Lägg till länk",
    "delete": "Ta bort länk",
    "table": {
      "original": "Original",
      "language": "Språk",
      "translation": "Översättning",
      "action": "Åtgärd",
      "delete_confirm": "Bekräfta borttagning av länk"
    }
  },
  "members": {
    "header": "Medlemmar",
    "invite": "Bjud in ny medlem",
    "modal": {
      "inviteHeader": "Bjud in ny medlem",
      "editHeader": "Redigera medlem",
      "detachHeader": "Koppla bort medlem",
      "detachBody": "Är du säker på att du vill koppla bort medlemmen från detta konto?",
      "selfDetachBody": "Är du säker på att du vill koppla bort dig själv från hanteringen av detta konto? Efter det kommer du inte att kunna komma åt någon data relaterad till detta konto."
    },
    "table": {
      "title": "Medlemslista",
      "description": "Medlemmars roller och domänåtkomst",
      "name": "Namn",
      "email": "E-post",
      "websites": "Webbplatser",
      "languages": "Språk",
      "role": "Roll",
      "status": "Status",
      "resendInvite": "skicka igen",
      "inviteSent": "inbjudan skickades",
      "actions": "Åtgärder",
      "edit": "Redigera",
      "detach": "Koppla bort",
      "empty": "Du har inga medlemmar än",
      "all_website": "Alla webbplatser och språk",
      "roles": {
        "admin": "Administratör",
        "manager": "Chef",
        "translator": "Översättare"
      },
      "statuses": {
        "pending": "Väntande",
        "accepted": "Accepterad",
        "declined": "Avvisad"
      }
    },
    "errors": {
      "role": "Du måste välja en roll",
      "domains": "Du måste välja minst 1 webbplats för vald roll",
      "languages": "Du måste välja minst 1 språk för valda webbplatser"
    },
    "inviteSent": "Din inbjudan har skickats"
  },
  "pagination": {
    "showing": "Visar {{limit}} av {{total}} resultat",
    "showing_only_count": "Visar {{limit}} resultat"
  },
  "payments_method": {
    "header": "Betalningsmetoder",
    "table": {
      "title": "Lista över betalningsmetoder",
      "description": "Bifogade betalningsmetoder till ditt konto",
      "default": "Standard",
      "action_edit_remove": "Redigera eller ta bort",
      "action_remove": "Ta bort",
      "action_default": "Ange som standard",
      "action_fallback": "Ange som reserv",
      "expires": "Går ut",
      "add_new_card": "Lägg till betalningsmetod",
      "action_fallback_remove": "Ta bort från reserv",
      "fallback": "Reserv",
      "action_edit": "Redigera",
      "action_delete": "Radera",
      "action_default_remove": "Ta bort som standard",
      "domain_count@@one": "Används av {{count}} domäner",
      "domain_count@@other": "Används av {{count}} domäner"
    },
    "paypal_bind": {
      "button": "Anslut PayPal-konto",
      "button_load": "Ansluter...",
      "disconnected": "Inte ansluten",
      "success": "Ditt PayPal-konto är nu anslutet, 5 $ dras av från din nästa faktura!",
      "success_no_promo": "Ditt PayPal-konto är nu anslutet",
      "error": "Ett fel uppstod",
      "success_header": "Klart"
    },
    "card_add": {
      "header": "Lägg till nytt kort",
      "success": "Nytt kort anslutet till Linguise!",
      "terms": "Genom att ange din kortinformation tillåter du Linguise att debitera ditt kort för framtida betalningar enligt våra användarvillkor."
    },
    "card_detail": {
      "header": "Kortinfo",
      "delete": {
        "error": "Du kan inte ta bort denna betalningsmetod eftersom den har aktiva prenumerationer!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Prenumerationer på denna betalningsmetod",
        "header_domain": "Domän",
        "header_plan": "Abonnemang",
        "header_status": "Status",
        "header_actions": "Åtgärder",
        "cancelling": "Sägs upp: {{0}}",
        "next_payment": "Nästa betalning: {{0}}",
        "action_renew": "Förnya",
        "no_subs_header": "Inga prenumerationer att visa",
        "no_subs_desc": "När en prenumeration görs på detta kort kommer all information att visas här",
        "action_manage": "Hantera"
      },
      "status": {
        "active": "Aktiv",
        "canceled": "Avbruten",
        "incomplete": "Obetald",
        "incomplete_expired": "Obetald (utgången)",
        "missing": "Fel",
        "past_due": "Försenad",
        "trialing": "Testperiod",
        "unpaid": "Obetald"
      }
    },
    "delete_confirm_body": "Är du säker på att du vill ta bort denna betalningsmetod? Denna åtgärd kan inte ångras!",
    "delete_confirm_header": "Ta bort betalningsmetod?",
    "card_edit": {
      "header": "Redigera kort",
      "billing_header": "Faktureringsinformation",
      "address_error": "Adress krävs!",
      "card_number": "Kortnummer",
      "card_expiry": "Utgångsdatum",
      "expiry_error_month": "Ogiltig månad angiven",
      "expiry_error_year": "Ogiltigt år angivet",
      "expiry_error_expired": "Ditt korts utgångsår har passerats.",
      "card_header": "Kortinformation",
      "expiry_error_empty": "Det här fältet är obligatoriskt!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "översatta ord",
    "current": "Aktuell",
    "archived": "Arkiverad",
    "day": "dag",
    "week": "vecka",
    "month": "månad",
    "year": "år",
    "activate": "Aktivera",
    "cancel": "Avbryt",
    "change": "Ändra",
    "upgrade": "Uppgradera",
    "downgrade": "Nedgradera",
    "resume": "Återuppta",
    "notEnoughWords": "Inte tillräckligt med ord",
    "yearIntervalOnly": "Kan inte migrera från årsplan",
    "subsCanceled": "Det finns en annan pågående avbokning av prenumeration",
    "wordsUnlimited": "Obegränsat antal ord",
    "tabs": {
      "day": "Dagliga priser",
      "week": "Veckopriser",
      "month": "Månadspriser",
      "year": "Årspriser",
      "sub_texts": {
        "day": "Ett fast pris, varje dag",
        "week": "Ett fast pris, varje vecka",
        "month": "Ett fast pris, varje månad",
        "year": "En månad gratis, en faktura per år"
      }
    },
    "details": {
      "new_languages": "Lägg till nya språk när som helst",
      "one_month_trial": "En månads gratis provperiod för varje ny webbplats",
      "multi_content_indexed": "100 % av det flerspråkiga innehållet indexerat",
      "translate_new_content": "Översätt nytt innehåll direkt",
      "free_installation": "Gratis installation och konfigurering",
      "compared_monthly_plan": "En månad gratis jämfört med månadsplaner",
      "risk_free_recurring": "Riskfritt återkommande misslyckade betalningar",
      "unlimited_languages": "Obegränsat antal språk och sidvisningar",
      "high_server_resources": "Höga serverresurser",
      "billed": {
        "day": "Faktureras dagligen",
        "week": "Faktureras veckovis",
        "month": "Faktureras månadsvis",
        "year": "Faktureras årsvis"
      },
      "request_max_size": "{{0}} maximal förfrågningsstorlek"
    },
    "frequent_question": {
      "title": "Vanliga frågor",
      "questions": {
        "trial": {
          "question": "Kan jag använda provperioden på en ny domän?",
          "answer": "Ja, vi erbjuder en 30-dagars gratis provperiod för varje ny domän du lägger till i ditt konto. På så sätt kan du testa översättningstjänsten fullt ut på din nya webbplats."
        },
        "seo": {
          "question": "Hur lång tid tar det innan min SEO förbättras?",
          "answer": "Innehåll och flerspråkigt innehåll tar tid att bli fullständigt indexerat och väl rankat. Beroende på din webbplatstrafik och storlek tar det mellan 3 och 6 veckor."
        },
        "quota": {
          "question": "Inkluderas mänskliga översättningar i kvoten?",
          "answer": "Nej, ordgränsen gäller endast automatiska maskinöversättningar. En översättare kan redigera automatiska översättningar manuellt utan gräns."
        }
      }
    },
    "best_offer": "Bästa erbjudandet",
    "period": {
      "days@@one": "dag",
      "days@@other": "{{count}} dagar",
      "hours@@one": "timme",
      "hours@@other": "{{count}} timmar",
      "minutes@@one": "minut",
      "minutes@@other": "{{count}} minuter",
      "seconds@@one": "sekund",
      "seconds@@other": "{{count}} sekunder"
    },
    "words": {
      "billion": "{{value}} miljarder",
      "million": "{{value}} miljoner",
      "thousand": "{{value}} tusen"
    },
    "throttling_info": "{{words}} ord per {{period}}"
  },
  "profile": {
    "welcome": "Välkommen!",
    "account": "Mitt konto",
    "subscriptions": "Prenumerationer",
    "logout": "Logga ut"
  },
  "register": {
    "errors": {
      "password": "Minst 8 tecken, valfria tecken"
    }
  },
  "route": {
    "dashboard": "Kontrollpanel",
    "rules": "Regler",
    "translations": "Översättningar",
    "search_translations": "Sökfrågor",
    "urls_translations": "URL-översättningar",
    "links": "Media och externa länkar",
    "online_editor": "Live-redigerare",
    "settings": "Inställningar",
    "domain": {
      "finish": "Inställningar",
      "preconfig": "Inställningar"
    },
    "home": "Hem",
    "domain_list": "Domänlista",
    "members": "Medlemmar",
    "invoices": "Fakturor",
    "billing": "Faktureringsuppgifter",
    "language_display": "Språkflaggor",
    "payment_methods": "Betalningsmetoder",
    "ai_translation": "AI-översättning",
    "ai_translation_settings": "Inställningar",
    "ai_translation_pricing": "Prissättning"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Text att ignorera",
        "add": "Lägg till ny",
        "title": "Text att ignorera",
        "description": "Lägg till en eller flera texter att ignorera",
        "ignore_case": "Ignorera skiftläge"
      },
      "html_content": {
        "title": "Tillämpa på HTML-innehåll",
        "description": "Tillämpa regel på hela innehållet eller genom att välja en specifik CSS-selektor",
        "all_page": "Hela sidan",
        "css_selector": "CSS-selektor",
        "label": "CSS-selektor",
        "placeholder": "Selektor att tillämpa på",
        "add": "Lägg till ny"
      },
      "apply_to_urls": {
        "title": "Tillämpa på webbadresser",
        "description": "Välj specifika webbadresser där du vill att regeln ska tillämpas",
        "all_urls": "Alla webbadresser",
        "selected_urls": "Valda webbadresser",
        "label": "Webbadress att tillämpa på",
        "placeholder": "Webbadress att tillämpa på",
        "original_url": "Ursprungliga webbadresser",
        "translated_url": "Översatt webbadress",
        "wildcard": "Jokertecken",
        "regex": "Reguljärt uttryck",
        "add": "Lägg till ny",
        "expression": "Uttryckstyp"
      },
      "apply_urls": {
        "title_exclude": "Uteslut i webbadresser",
        "title_replace": "Ersätt i webbadresser",
        "title_description": "Tillämpa även denna regel på översättning av webbadresser"
      },
      "apply_languages": {
        "title": "Tillämpa på språk",
        "description": "Välj specifikt språk där du vill att regeln ska tillämpas",
        "all_languages": "Alla språk",
        "selected_languages": "Valda språk",
        "placeholder": "Välj språk...",
        "feedback": "Du måste välja ett språk"
      },
      "name": {
        "title": "Titel",
        "description": "Ge din regel en titel för bekvämlighetens skull",
        "placeholder": "Regelnamn"
      },
      "type": {
        "title": "Typ",
        "description": "Välj vilken typ av regel du vill lägga till",
        "text_ignore": "Textignorering",
        "text_replace": "Text ersättning",
        "content_exclusion": "Innehållsuteslutning",
        "url_exclusion": "Uteslutning via webbadress",
        "ignore_inline": "Ignorera inline",
        "full_description": {
          "text_ignore": "Lägg till regler för att undvika att viss text översätts. Det kan vara ditt produktnamn, varumärke eller andra tekniska element som du inte vill ska översättas.",
          "text_replace": "Text ersättning låter dig ersätta viss text med den översättning du önskar, vilket kan behövas när översättningen ignorerar sammanhanget.",
          "content_exclusion": "Innehållsuteslutning hjälper dig att undvika översättning av viss del av sidan.\nOm du vill helt utesluta en sida från översättning (ingen flerspråkig webbadress alls för den sidan och ingen översatt text) använd då typen \"Uteslutning via webbadress\"",
          "url_exclusion": "Uteslutning av sidöversättning hjälper dig att ange vilka sidor du inte vill ska översättas.",
          "ignore_inline": "Undvik att översätta viss inline-innehåll, översätt i stället varje tagg separat."
        }
      },
      "text_replace": {
        "title": "Text att ersätta",
        "description": "Ersätt viss text med din specifika översättning. Ersätt valfri text över hela din webbplats, per språk…",
        "text_to_replace": "Text att ersätta",
        "ignore_case": "Ignorera skiftläge",
        "text_type": "Ersättning i översättning",
        "text_type_original": "Original",
        "text_type_translation": "Översättning",
        "keep_case": "Försök behålla skiftläge",
        "add": "Lägg till ny"
      },
      "content_exclusion": {
        "title": "Innehållsuteslutning",
        "description": "Välj en eller flera CSS-selektorer som inte ska översättas",
        "label": "CSS-selektor",
        "placeholder": "Selektor att tillämpa på",
        "add": "Lägg till ny"
      },
      "multilingual_url": {
        "title": "Använd flerspråkig webbadress",
        "description": "Om du sätter Ja kommer webbadressen INTE att översättas men sidan förblir flerspråkig med översatt innehåll",
        "live_example_title": "Live-exempel",
        "live_example_description": "Käll-URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Genererad URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Genererad URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Tillämpa regeln på statiskt innehåll eller dynamiskt innehåll eller båda",
        "title": "Tillämpa på innehåll",
        "all": "Allt innehåll",
        "static": "Statiskt innehåll",
        "dynamic": "Dynamiskt innehåll"
      },
      "force_apply_urls": {
        "title_description": "Tvinga tillämpning av denna regel på all översättning av webbadresser, inklusive befintliga översättningar!",
        "title_replace": "Tvinga ersättning i webbadresser",
        "title_exclude": "Tvinga uteslutning i webbadresser",
        "warning": "Varning",
        "warning_part1": "Att sätta detta till \"Ja\" kan bryta dina webbadressöversättningar.",
        "warning_part2": "Detta kan tillfälligt eller permanent generera en 404-sida, fortsätt endast om du förstår konsekvenserna.",
        "warning_replacement_original": "Ytterligare varning: Du försöker ersätta originalinnehåll som kan påverka webbadresser, översättningen kan misslyckas eftersom Linguise inte hittar de ursprungliga webbadresserna korrekt"
      }
    },
    "main": {
      "parent": "Regler",
      "edit": "Redigera regel",
      "add": "Ny regel"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" kommer att ignoreras i innehållet och i webbadressen",
      "preview_single": "\"{{text_ignore}}\" kommer att ignoreras i innehållet",
      "preview_more_with_url": "\"{{text_ignore}}\" och {{count}} till kommer att ignoreras i innehållet",
      "preview_more": "\"{{text_ignore}}\" och {{count}} till kommer att ignoreras i innehållet",
      "other_parameters": "Andra parametrar är inställda för denna regel, klicka på redigera-knappen för mer information"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" ersätts av \"{{replacement}}\" i innehållet och webbadresserna",
      "preview_single": "\"{{original}}\" ersätts av \"{{replacement}}\" i innehållet",
      "preview_more_with_url": "\"{{original}}\" ersätts av \"{{replacement}}\" i innehållet och webbadresserna, samt {{nb}} till",
      "preview_more": "\"{{original}}\" ersätts av \"{{replacement}}\" i innehållet, samt {{nb}} till",
      "other_parameters": "Andra parametrar är inställda för denna regel, klicka på redigera-knappen för mer information"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS-selektor(er) exkluderade från översättning",
      "other_parameters": "Andra parametrar är inställda för denna regel, klicka på redigera-knappen för mer information"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} webbadresser är exkluderade från översättning, men behåller ändå flerspråkigt prefix",
      "some": "{{nb}} webbadresser är helt exkluderade från översättning",
      "all_multilingual": "alla webbadresser är exkluderade från översättning, men behåller ändå flerspråkigt prefix",
      "all": "alla webbadresser är helt exkluderade från översättning",
      "other_parameters": "Andra parametrar är inställda för denna regel, klicka på redigera-knappen för mer information"
    },
    "ignore_inline": {
      "elements": "Allt inline-innehåll kommer att översättas som blockinnehåll på sidan",
      "all_elements": "Viss inline-innehåll kommer att översättas som blockinnehåll på sidan",
      "other_parameters": "Andra parametrar är inställda för den här regeln, klicka på redigeringsknappen för att få mer information"
    },
    "title": "Hantering av regler",
    "description": "Hantera dina översättningars innehållsuteslutningar och ersättningar över hela din webbplats",
    "add": "Lägg till ny regel",
    "table": {
      "title": "Titel",
      "no_data": "Inga regler här än",
      "type": "Typ",
      "preview": "Förhandsvisning av regel",
      "action": "Åtgärd",
      "delete_confirm": "Vänligen bekräfta borttagning av regel",
      "types": {
        "text_ignore": "Ignorera text",
        "text_replace": "Ersätt text",
        "content_exclusion": "Uteslutning av innehåll",
        "url_exclusion": "Uteslutning av URL",
        "ignore_inline": "Ignorera inline",
        "unknown": "Okänd regel"
      }
    },
    "apply_on_content": {
      "static": "Denna regel kommer endast att tillämpas på statiskt innehåll",
      "dynamic": "Denna regel kommer endast att tillämpas på dynamiskt innehåll"
    }
  },
  "search_translations": {
    "title": "Hantering av sökfrågor",
    "description": "Lista alla dina webbplatsöversättningar som används via sökformulär (från översatt språk till ditt domäns baspråk)",
    "filter_languages": "Filtrera efter språk...",
    "filter_original": "Filtrera text i originalspråk",
    "filter_translation": "Filtrera efter översatt text",
    "table": {
      "original": "Original",
      "language": "Språk",
      "translation": "Översättning"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Det gick inte att prenumerera!",
      "title": "Det gick inte att prenumerera!",
      "subtitle": "Ett fel uppstod när din prenumeration försökte bearbetas.",
      "home": "Gå tillbaka till startsidan",
      "generic": "Ett okänt fel har uppstått på Linguises sida, kontakta administratören!"
    },
    "success": {
      "home": "Hantera domänöversättningar",
      "message": "Vi är engagerade i att ge dig den bästa möjliga översättningsupplevelsen. Vårt team av experter finns tillgängligt för att hjälpa dig med eventuella frågor eller support du behöver. För att komma igång klickar du helt enkelt på knappen nedan.",
      "subtitle": "Tack för att du valt Linguise översättningstjänst",
      "title": "Prenumeration aktiverad!",
      "tab_title": "Tack för prenumerationen!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Prenumeration aktiverad!",
      "title": "Prenumeration aktiverad!",
      "subtitle": "Tack för att du valt Linguise översättningstjänst",
      "message": "Vi är engagerade i att ge dig den bästa möjliga översättningsupplevelsen. Vårt team av experter finns tillgängligt för att hjälpa dig med eventuella frågor eller support du behöver. För att komma igång klickar du helt enkelt på knappen nedan.",
      "home": "Hantera domänöversättningar"
    },
    "edit": {
      "title": "Hantera prenumeration"
    },
    "list": {
      "title": "Prenumerationslista",
      "description": "Lista över dina domänprenumerationer"
    },
    "table": {
      "domain": "Domän",
      "plan": "Abonnemang",
      "status": "Status",
      "card": "Kort",
      "usage": "Användning",
      "actions": "Åtgärder",
      "payment_method": "Betalningsmetod"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} ord",
      "paidOffered": "{{words_used}} / {{words_allowed}} ord\n(Inkluderar {{free_words}} erbjudna ord)"
    },
    "popup": {
      "dueToday": "Totalt förfallo idag",
      "nextPeriod": "Från och med {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Välj ett konto"
    }
  },
  "translation": {
    "main": {
      "parent": "Översättningar",
      "edit": "Redigera översättning"
    },
    "form": {
      "original": {
        "title": "Original på {{language}}"
      },
      "is_inline": "Denna översättning görs från inline-innehåll.",
      "inline_editor": {
        "count_warning": "Antalet inlineområden stämmer inte överens med originalet ({{current}} av {{expected}}).",
        "restore_original": "Återställ originaltexten",
        "insert_placeholder": "Infoga platshållare",
        "drag": "Dra för att ändra områdets ordning",
        "area": "Inbäddat område {{index}}",
        "restore": "Återställ saknade inlineområden"
      },
      "translation": {
        "title": "Översättning på {{language}}",
        "description": "Översättning du vill skriva över"
      }
    },
    "copy": {
      "title": "Kopiera till den manuella översättningen",
      "label": "Kopiera till manuell"
    },
    "level": {
      "base": {
        "title": "Grundöversättning",
        "subtitle": "Automatisk · Linguise Cloud-översättning",
        "empty": "Ingen grundöversättning för den här texten.",
        "overridden": "Ditt val är sparat, men den senaste AI-förbättrade översättningen visas i stället eftersom ”Åsidosätt manuella och valda översättningar” är satt till Ja i inställningarna för AI-översättning. Stäng av inställningen för att använda ditt val."
      },
      "not_generated": "Inte skapad",
      "none": "Inget ännu",
      "ai": {
        "title": "AI-förbättrad översättning",
        "subtitle": "Automatisk · Linguise AI",
        "empty_title": "Inte skapad för den här texten än",
        "empty_description": "Linguise AI ger mer naturliga översättningar med hjälp av sammanhanget på din sida och webbplats. Så här får du en här:",
        "empty_step_1": "Gå till AI-översättning › Inställningar och ställ in Aktivera AI-översättning på ”Endast regler”, ”Endast live-redigerare” eller ”Regler och live-redigerare”.",
        "empty_step_2": "Tillämpa den med en regel som matchar den här sidan, eller aktivera den sida för sida från Live Editor.",
        "empty_step_3": "Den AI-förbättrade översättningen visas här när den har skapats. Den använder dina AI-krediter.",
        "open_settings": "Öppna inställningar för AI-översättning",
        "open_editor": "Öppna Live Editor",
        "overrides_selection": "Ditt val är sparat, men den här AI-förbättrade översättningen visas i stället eftersom ”Åsidosätt manuella och valda översättningar” är satt till Ja i inställningarna för AI-översättning. Stäng av inställningen för att använda ditt val.",
        "overrides_version": "Versionen du valde är sparad, men den senaste AI-förbättrade versionen visas i stället eftersom ”Åsidosätt manuella och valda översättningar” är satt till Ja i inställningarna för AI-översättning. Stäng av inställningen för att använda den valda versionen."
      },
      "manual": {
        "title": "Manuell översättning",
        "subtitle": "Skriven av dig · har företräde framför automatiska översättningar",
        "empty": "Tom",
        "saved_but_overridden": "Sparad som ditt val, men visas inte automatiskt eftersom ”Åsidosätt manuella översättningar” är satt till Ja i inställningarna för AI-översättning: den AI-förbättrade översättningen gäller tills inställningen stängs av.",
        "ignored": "Visas inte automatiskt eftersom ”Åsidosätt manuella översättningar” är satt till Ja i inställningarna för AI-översättning. Välj den för att använda den för den här texten.",
        "label": "Din översättning",
        "placeholder": "Skriv din egen översättning...",
        "last_updated": "Senast redigerad {{date}}",
        "save_hint": "När du sparar en manuell översättning blir den aktiv.",
        "delete": "Ta bort manuell översättning",
        "delete_confirm": "Bekräfta borttagning av den manuella översättningen"
      }
    },
    "history": {
      "title": "AI-förbättrade versioner",
      "subtitle": "Varje ny generering från Live Editor sparas",
      "unknown_model": "Okänd modell",
      "current": "Aktuell",
      "restore": "Återställ den här versionen",
      "restore_note": "När du återställer blir den versionen den aktuella AI-förbättrade översättningen. Inget raderas.",
      "version_of": "Version {{current}} av {{total}}",
      "hide": "Dölj historik ({{total}})",
      "show": "Visa historik ({{total}})"
    },
    "choose": {
      "title": "Översättningar på {{language}} · välj den som besökarna ser",
      "current": "Visas just nu på din webbplats:",
      "priority": "Standardprioritet: Manuell › AI-förbättrad › Grund. Ditt val sparas endast för den här översättningen.",
      "reset": "Återställ till standardprioritet",
      "reset_title": "Glöm ditt val för den här texten och använd standardprioriteten igen",
      "resetting": "Återställer..."
    }
  },
  "translations": {
    "title": "Hantering av översättningar",
    "description": "Lista och redigera alla dina webbplatsöversättningar, för visuell översättning använd Live Editor",
    "filter_languages": "Filtrera efter språk...",
    "filter_original": "Filtrera text i originalspråk",
    "filter_translation": "Filtrera efter översatt text",
    "table": {
      "original": "Original",
      "language": "Språk",
      "action": "Åtgärd",
      "base": "Grund",
      "ai": "AI-förbättrad",
      "manual": "Manuell"
    },
    "filter_exact": "Exakt matchning",
    "badge": {
      "active": "Aktiv",
      "overrides_manual": "Åsidosätter manuell"
    },
    "cell": {
      "none": "ingen",
      "not_generated": "inte skapad",
      "ignored": "Ignorerad – AI-regeln gäller"
    },
    "tabs": {
      "all": "Alla",
      "manual": "Har manuell",
      "ai": "Har AI-förbättrad",
      "base": "Endast grund"
    },
    "levels_hint": "Varje text har upp till 3 nivåer – den som är markerad som Aktiv är den som besökarna ser."
  },
  "url": {
    "main": {
      "parent": "URL:er",
      "edit": "Redigera URL-översättning"
    },
    "form": {
      "original": {
        "title": "Original på {{language}}"
      },
      "translation": {
        "title": "URL-översättning på {{language}}",
        "description": "URL du vill skriva över",
        "placeholder": "Överskrivning av URL-översättning",
        "invalid_full": "Du försöker ändra till felaktigt format, du bör endast ändra slugs/sökvägar i URL-översättningen",
        "invalid": "Ogiltig URL/sökväg angiven"
      }
    }
  },
  "urls": {
    "title": "Hantering av URL:er",
    "description": "Lista och redigera all översatt URL-innehåll på din webbplats (avancerat, akta dig för 404-fel)",
    "filter_languages": "Filtrera efter språk...",
    "filter_original": "Filtrera text i originalspråk",
    "filter_translation": "Filtrera efter översatt text",
    "table": {
      "original": "Original",
      "language": "Språk",
      "url": "Översatt URL",
      "action": "Åtgärd",
      "edited": "Den ursprungliga översättningen har redigerats"
    }
  }
}
